import {AxiosError} from "axios";
import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import { appEnv } from "./appEnv";
import {getCookie} from "typescript-cookie";
import type {AxiosLoginBaseQueryConfig} from "@app/api/apiLogin/typesLogin.ts";
import type {BaseQueryError} from "@shared/types/baseQueryError.ts";
import {AxiosSingletonInstance} from "@app/api/AxiosSingletonInstances.ts";

const axiosBaseQuery = (
    baseURL: string,
): BaseQueryFn<AxiosLoginBaseQueryConfig, unknown, BaseQueryError> => {
    const axiosInstance = AxiosSingletonInstance.getInstance({
        refreshTokenUrl: `${appEnv.CONFIGURADOR_BASEURL}/auth/refresh`,
        cookieName: appEnv.COOKIE_NAME
    });
    return async ({ url, data, method, params }) => {
        try {
            const result = await axiosInstance({
                url: `${baseURL}${url}`,
                data,
                method,
                params,
                headers: { Authorization: `Bearer ${getCookie(appEnv.COOKIE_NAME)}` },
            });
            return { data: result.data };
        } catch (error) {
            const axiosError = error as AxiosError<BaseQueryError>;
            const baseError: BaseQueryError = {
                message: axiosError.response?.data?.message || axiosError.message || 'Unkown error occurred',
                status: axiosError.response?.status || 500,
                name: axiosError.name || 'AxiosError',
            };
            return {
                error: baseError,
            };
        }
    }
}

export default axiosBaseQuery;